module.exports = __webpack_public_path__ + "img/mobile-headder-icons.7c97e07d.svg";